import classNames from 'classnames';
import React from 'react';
import { Button } from '../../../../../../ui';
import { ClockIcon, OpenLockIcon } from '../../../../../../ui/icons/icons';
import { SecondaryTypography } from '../../../../../../ui/typography/typography';
import { convertSecondsToTimeTaken } from '../../../../../../utils/helpers/time';
import { UserAssessment } from '../../../../../../utils/types/assessment_types';
import commonStyles from '../../assigned_assessments.module.css';
import styles from './selected_assessment_modal.module.css';

type SelectedAssessmentModalProps = {
  selectedAssessment: UserAssessment | undefined;
  setModalContent: (content: number) => void;
  setIsPractice: (value: boolean) => void;
  setAfterHelpModalContent: (content: number) => void;
};

export const SelectedAssessmentModal = ({
  selectedAssessment,
  setModalContent,
  setIsPractice,
  setAfterHelpModalContent,
}: SelectedAssessmentModalProps) => {
  const HELP_SEEN_KEY = 'hiacuity_help_seen';

  const handleStartFlow = (isPracticeMode: boolean) => {
    setIsPractice(isPracticeMode);
    const alreadySeen = localStorage.getItem(HELP_SEEN_KEY);
    if (!alreadySeen) {
      // First time — show help screens, then go to privacy (5)
      setAfterHelpModalContent(5);
      setModalContent(4);
    } else {
      // Already seen — go directly to privacy notice (5)
      setModalContent(5);
    }
  };
  return (
    <div className={commonStyles.modalContentContainer}>
      <SecondaryTypography.Small
          className={commonStyles.greyText}
          keepDefaultMargins={true}
      >
        { selectedAssessment && selectedAssessment.assessment.description }
      </SecondaryTypography.Small>
      <div className={styles.assessmentInfoContainer}>
        <div
            className={classNames(
              commonStyles.iconInfoContainer,
              commonStyles.darkBlueText,
            )}
        >
          <div
              className={classNames(
                commonStyles.iconClass,
                styles.lockIconGradient,
              )}
          >
            <OpenLockIcon />
          </div>
          <SecondaryTypography.Small fontWeight='semi-bold'>
            Total:{ ' ' }
            { selectedAssessment && selectedAssessment.assessment.totalScore }{ ' ' }
            points
          </SecondaryTypography.Small>
        </div>
        <div
            className={classNames(
              commonStyles.greyText,
              commonStyles.iconInfoContainer,
            )}
        >
          <div
              className={classNames(
                commonStyles.iconClass,
                styles.lockIconGradient,
              )}
          >
            <ClockIcon />
          </div>
          <SecondaryTypography.Small fontWeight='semi-bold'>
            Duration:{ ' ' }
            { selectedAssessment &&
              selectedAssessment.assessment.totalTime &&
              convertSecondsToTimeTaken(
                selectedAssessment.assessment.totalTime,
              ) }{ ' ' }
            minutes
          </SecondaryTypography.Small>
        </div>
      </div>
      { /*<SecondaryTypography.Small*/ }
      { /*    className={commonStyles.greyText}*/ }
      { /*    keepDefaultMargins={true}*/ }
      { /*>*/ }
      { /*  You can take practise the tutorial before proceeding to the actual assessment. These marks will not be taken into consideration.*/ }
      { /*</SecondaryTypography.Small>*/ }
      <SecondaryTypography.Small
          className={commonStyles.greyText}
          keepDefaultMargins={true}
      >
        Disclaimer: During the process of the assessment your browser actions
        will be monitored.
      </SecondaryTypography.Small>
      <SecondaryTypography.Small className={commonStyles.redText}>
        Warning: Once you start the assessment, you must complete it and you
        cannot re-take it again.
      </SecondaryTypography.Small>
      <div className='flex items-center gap-3 mt-5 w-full justify-end border-t border-primary-background pt-5'>
        <Button
            onClick={() => handleStartFlow(true)}
            variant='secondary'
            label='Practice Tutorial'
        />
        <Button
            onClick={() => handleStartFlow(false)}
            variant='primary'
            label='Start Assessment'
        />
      </div>
    </div>
  );
};
